import { useState, useEffect, useCallback, useMemo } from 'react';
import { useUserConfig } from './useUserConfig';

export function usePagination(configKey, defaultPageSize = 50) {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useUserConfig(configKey, defaultPageSize);
  const [totalCount, setTotalCount] = useState(0);
  const [pageInput, setPageInput] = useState('1');

  const totalPages = Math.ceil((totalCount || 0) / pageSize);

  // 頁碼修正
  useEffect(() => {
    if (totalCount >= 0) {
      if (currentPage > totalPages && totalPages > 0) {
        setCurrentPage(totalPages);
        setPageInput(totalPages.toString());
      } else if (currentPage < 1 && totalPages > 0) {
        setCurrentPage(1);
        setPageInput('1');
      }
    }
  }, [totalCount, pageSize, currentPage, totalPages]);

  const handlePageChange = useCallback((page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setPageInput(page.toString());
    }
  }, [totalPages]);

  const handlePageSizeChange = useCallback((e) => {
    setPageSize(Number(e.target.value));
    setCurrentPage(1);
    setPageInput('1');
  }, [setPageSize]);

  const handlePageInputChange = useCallback((e) => {
    setPageInput(e.target.value);
  }, []);

  const handlePageInputSubmit = useCallback(() => {
    const page = parseInt(pageInput);
    if (!isNaN(page) && page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    } else {
      setPageInput(currentPage.toString());
    }
  }, [pageInput, totalPages, currentPage]);

  const handlePageInputKeyPress = useCallback((e) => {
    if (e.key === 'Enter') handlePageInputSubmit();
  }, [handlePageInputSubmit]);

  const resetPage = useCallback(() => {
    setCurrentPage(1);
    setPageInput('1');
  }, []);

  return useMemo(() => ({
    currentPage,
    pageSize,
    totalCount,
    pageInput,
    totalPages,
    setTotalCount,
    handlePageChange,
    handlePageSizeChange,
    handlePageInputChange,
    handlePageInputSubmit,
    handlePageInputKeyPress,
    resetPage,
  }), [
    currentPage, pageSize, totalCount, pageInput, totalPages,
    setTotalCount, handlePageChange, handlePageSizeChange,
    handlePageInputChange, handlePageInputSubmit, handlePageInputKeyPress, resetPage,
  ]);
}
